module.exports = __webpack_public_path__ + "21dc60ad002770367f8e9b73ee247571.jpg";